import {formatLicenseDate} from 'src/modules/profile/utils/formatLicenseDate';

import type {LicenseInfo} from 'src/openapi/admin/models/LicenseInfo';
import type {LicenseShortInfo} from 'src/openapi/admin/models/LicenseShortInfo';

export const getLicenseCaption = (
    license: LicenseInfo | LicenseShortInfo,
    dateFormat: string,
    code?: string) => [
    formatLicenseDate(dateFormat, license.startDate),
    '-',
    formatLicenseDate(dateFormat, license.endDate),
    code ? `(${code})` : '',
].join(' ');
